import { AdditionalFees } from '@bookingkit/api-v4/models/additional-fees';
import { PaymentMethodAdditionalFeesType } from '@/modules/sell/pages/PaymentMethods/types';
import { AccountingServiceError } from '@/services/AccountingService/Errors/AccountingServiceError';

/**
 * Absent fees (undefined or null) map to undefined; fees that are present must carry a numeric variable.
 */
export const fromApiAdditionalFeesToAdditionalFees = (
    fees?: AdditionalFees | null,
): PaymentMethodAdditionalFeesType | undefined => {
    if (fees === undefined || fees === null) {
        return undefined;
    }
    if (typeof fees.variable !== 'number') {
        throw AccountingServiceError.fromMissingProperty('Additional fees variable');
    }
    return {
        variable: fees.variable,
    };
};

export default { fromApiAdditionalFeesToAdditionalFees };
